<div class="input-wrapper estimate-measurement-search">
    <i class="prefix fa-light fa-magnifying-glass"></i>
    <input [value]="searchInput$ | async" (input)="onFilterChanges($event)" class="text-input" placeholder="Search..." />
    <button id="estimate-measurement-filter-search-reset" class="suffix btn-flat btn-small square" (click)="resetFilter()">
        <i class="fa-light fa-xmark"></i>
    </button>
</div>
